/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import { bool, func } from 'prop-types';
import { makeStyles, useMediaQuery } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    confirmModal: {
        position: 'absolute',
        top: '80px',
        width: '100%',
        zIndex: 9999,
        padding: '0 30px',
    },
    mediaModalDialog: {
        maxWidth: '100%',
        margin: '0 auto',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#fff !important',
        border: '1px solid rgba(0,0,0,.2)',
        borderRadius: '.3rem',
        outline: '0',
    },
    confirmModalDialog: {
        maxWidth: '100%',
        margin: '0 auto',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#fff !important',
        border: '1px solid rgba(0,0,0,.2)',
        borderRadius: '.3rem',
        outline: '0',
    },
    confirmModalContent: {
        backgroundColor: '#fff',
        boxShadow: '0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12)',
    },
    confirmModalBody: {
        overflow: 'auto',
        textAlign: 'center',
        padding: '1rem',
    },
    confirmModalFooter: {
        borderTop: 0,
        justifyContent: 'center',
        padding: '1rem',
        display: 'flex',
        alignItems: 'center',
    },
    confirmBtn: {
        marginLeft: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '.5rem .75rem',
        fontSize: '1rem',
        color: '#fff',
        '&:hover': {
            color: '#fff',
        },
        backgroundColor: `${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        border: `2px solid ${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        borderRadius: '.25rem',
        cursor: 'pointer',
    },
    confirmBtnOutline: {
        backgroundColor: '#fff',
        color: `${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        border: `2px solid  ${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        padding: '.5rem .75rem',
        fontSize: '1rem',
        borderRadius: '.25rem',
        marginLeft: '10px',
        cursor: 'pointer',
    },
}));

const ConfirmDialog = ({ closeChatConfirm, onCloseDialog, onCancelDialog }) => {
    const [responsiveModalDialogClass, setResponsiveModalDialogClass] = useState(undefined);
    const matches = useMediaQuery('(min-width: 576px)');
    const {
        mediaModalDialog,
        confirmBtn,
        confirmBtnOutline,
        confirmModal,
        confirmModalBody,
        confirmModalContent,
        confirmModalDialog,
        confirmModalFooter,
    } = useStyles();

    /**
     * Adjust modal styles to match the current resolution.
     */
    useEffect(() => {
        if (matches) {
            setResponsiveModalDialogClass(mediaModalDialog);
        } else {
            setResponsiveModalDialogClass(confirmModalDialog);
        }
    }, [matches]);

    return (
        closeChatConfirm ? (
            <div id="confirm" className={confirmModal}>
                <div className={responsiveModalDialogClass}>
                    <div className={confirmModalContent}>
                        <div className={confirmModalBody}>
                            Are you sure you want to close?
                        </div>
                        <div className={confirmModalFooter}>
                            <button
                                type="button"
                                onClick={onCloseDialog}
                                className={confirmBtn}
                                id="close"
                                data-testid="confirm-close-button"
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                onClick={onCancelDialog}
                                className={confirmBtnOutline}
                                data-testid="confirm-cancel-button"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        ) : null);
};

ConfirmDialog.propTypes = {
    closeChatConfirm: bool.isRequired,
    // functions
    onCloseDialog: func.isRequired,
    onCancelDialog: func.isRequired,
};
export default ConfirmDialog;
